var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/reply_mentions.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.to-array.js";
import React from 'react';
import { FormattedList, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { openModal } from 'soapbox/actions/modals';
import { useAppSelector } from 'soapbox/hooks';
import { statusToMentionsAccountIdsArray } from 'soapbox/reducers/compose';
import { makeGetStatus } from 'soapbox/selectors';
import { getFeatures } from 'soapbox/utils/features';
const ReplyMentions = () => {
  const dispatch = useDispatch();
  const instance = useAppSelector(state => state.instance);
  const status = useAppSelector(state => makeGetStatus()(state, {
    id: state.compose.in_reply_to
  }));
  const to = useAppSelector(state => state.compose.to);
  const account = useAppSelector(state => state.accounts.get(state.me));
  const {
    explicitAddressing
  } = getFeatures(instance);
  if (!explicitAddressing || !status || !to) {
    return null;
  }
  const parentTo = status && statusToMentionsAccountIdsArray(status, account);
  const handleClick = e => {
    e.preventDefault();
    dispatch(openModal('REPLY_MENTIONS'));
  };
  if (!parentTo || parentTo.size === 0) {
    return null;
  }
  if (to.size === 0) {
    return /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "reply-mentions",
      onClick: handleClick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reply_mentions.reply_empty",
      defaultMessage: "Replying to post",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 9
      }
    }));
  }
  const accounts = to.slice(0, 2).map(acct => /*#__PURE__*/React.createElement("span", {
    className: "reply-mentions__account",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, "@", acct.split('@')[0])).toArray();
  if (to.size > 2) {
    accounts.push(/*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reply_mentions.more",
      defaultMessage: "{count} more",
      values: {
        count: to.size - 2
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 7
      }
    }));
  }
  return /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "reply-mentions",
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reply_mentions.reply",
    defaultMessage: "Replying to {accounts}",
    values: {
      accounts: /*#__PURE__*/React.createElement(FormattedList, {
        type: "conjunction",
        value: accounts,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66,
          columnNumber: 21
        }
      })
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 7
    }
  }));
};
export default ReplyMentions;